<template>
  <div>
    <ASearchForm
      :modelName="'Transfer Order'"
      :create="false"
      :dropdownProps="[{type:'text',name: 'Name (contains)', payloadKey: 'name'},{model:'locations', name: 'Location', payloadKey: 'locationId'}]"
      @change="search"
      @create="onCreate"
      ref="ASearchForm"
      class="mb-5"
    ></ASearchForm>
    <ADataTable
      :headers="headers"
      :api="api"
      :sortBy="'name'"
      :exportable="true"
      @click:edit="onEdit"
      @click:delete="onDelete"
      :hideTitleBar="true"
      :apiParams="apiParams"
      ref="table"
    ></ADataTable>
    <AFormDialog
      ref="formDialog"
      :fields="formMeta"
      :modelName="'Transfer Order'"
      :model="'trackingorders'"
      :updateOnlyChanged="true"
      @modified="load"
    ></AFormDialog>
  </div>
</template>

<script>
import snackbar from "../../mixins/snackbar";
import ConfirmDialogMixin from "../../mixins/ConfirmDialogMixin";
import PermissionsHelper from "../../mixins/PermissionsHelper";
import ASearchForm from "../../components/ASearchForm";
import ADataTable from "../../components/ADataTable";
import AFormDialog from "../../components/AFormDialog";
import crudFuncsMixin from "../../mixins/CRUDFuncs";

import { time } from "../../utils";

export default {
  name: "TrackingOrders",
  mixins: [snackbar, ConfirmDialogMixin, crudFuncsMixin, PermissionsHelper],
  components: {
    ASearchForm,
    ADataTable,
    AFormDialog
  },
  data() {
    return {
      model: "trackingorders",
      headers: [
        {
          text: "Transfer Order ID",
          value: "name",
          sortable: false
        },
        {
          text: "Location",
          value: "locationName",
          cusOrderByName: "locationId",
          sortable: true
        },
        { text: "Last Scanned By", value: "LastScanByUser", sortable: true },
        {
          text: "Last Scan Time",
          value: "TimestampFormatted",
          cusOrderByName: "lastScan",
          sortable: true,
          format: {
            value: "lastScan",
            formatter: v => {
              return time.toTimestampFormat1(v);
            }
          }
        }
      ],
      apiParams: {},
      formMeta: {}
    };
  },
  methods: {
    search(payload) {
      this.apiParams = payload;
    }
  }
};
</script>



